/**
 * @generated SignedSource<<610968c30d8b7307cad2a63e96e4ac49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
export type TeamAdminIdentifiersScreenQuery$variables = {
  teamId: string;
};
export type TeamAdminIdentifiersScreenQuery$data = {
  readonly store: {
    readonly id: string;
    readonly publicTeams: ReadonlyArray<{
      readonly color: string | null;
      readonly icon: TeamIcon | null;
      readonly id: string;
      readonly name: string;
    }>;
    readonly team: {
      readonly color: string | null;
      readonly icon: TeamIcon | null;
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"TeamAdminIdentifiersScreen_team">;
    } | null;
  };
};
export type TeamAdminIdentifiersScreenQuery = {
  response: TeamAdminIdentifiersScreenQuery$data;
  variables: TeamAdminIdentifiersScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "publicTeams",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamAdminIdentifiersScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamAdminIdentifiersScreen_team"
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamAdminIdentifiersScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "677800fa0e520fe584f4d682501512f6",
    "id": null,
    "metadata": {},
    "name": "TeamAdminIdentifiersScreenQuery",
    "operationKind": "query",
    "text": "query TeamAdminIdentifiersScreenQuery(\n  $teamId: ID!\n) {\n  store {\n    id\n    team(id: $teamId) {\n      id\n      name\n      icon\n      color\n      ...TeamAdminIdentifiersScreen_team\n    }\n    publicTeams {\n      id\n      name\n      icon\n      color\n    }\n  }\n}\n\nfragment TeamAdminIdentifiersScreen_team on Team {\n  id\n  color\n  icon\n  name\n  isPrivate\n}\n"
  }
};
})();

(node as any).hash = "52ee91b07bc9b1ab0951dacd1bec271f";

export default node;
